import {removeSpecialCharacters} from "../../../../utils/string-helpers";

export class GameVendorDefinition {
    constructor(public readonly id: number,
        public readonly name: string) {
    }

    isMatch(regEx: RegExp): boolean {
        return Boolean(removeSpecialCharacters(this.name).match(regEx));
    }
}